import React from 'react';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';
import useCMSArticle from 'src/shared/hooks/cms/useCMSArticle';

export type SonDataset = {
    name: string;
    sourceKey: string;
    weight: number;
};

export type SonCategoryModalProps = {
    title: string;
    categorySlug: string;
    datasets: SonDataset[];
};

type DatasetRowProps = {
    dataset: SonDataset;
};

const DatasetRow = ({ dataset }: DatasetRowProps) => {
    const article = useCMSArticle(`son_${dataset.sourceKey}`);

    return (
        <tr className='align-top text-sm text-foreground'>
            <td className='py-4'>{dataset.name}</td>
            <td className='py-4'>
                <p>{article?.title ?? '—'}</p>
                <div className='text-xs text-muted-foreground' dangerouslySetInnerHTML={{ __html: article?.content ?? '' }} />
            </td>
            <td className='py-4 tabular-nums text-right whitespace-nowrap'>{dataset.weight}</td>
        </tr>
    );
};

const SonCategoryModal = ({ title, categorySlug, datasets }: SonCategoryModalProps) => {
    return (
        <div className='flex flex-col gap-4'>
            <h2 className='text-xl'>{title}</h2>

            <section>
                <h3 className=' text-primary mb-2'>About this category</h3>
                <div className='text-sm text-muted-foreground'>
                    <CMSArticle slug={categorySlug} variant='prose' />
                </div>
            </section>

            <section>
                <h3 className='text-primary mb-2'>Related Datasets</h3>
                <p className='pb-3 text-xs text-muted-foreground'>
                    Each dataset carries an indicator weight used in intra-category aggregation, otherwise treated as weight 1.0.
                </p>
                <table className='w-full text-sm border-collapse'>
                    <thead>
                        <tr className='border-b border-border'>
                            <th className='text-left py-2 font-medium'>Dataset Name</th>
                            <th className='text-left py-2 font-medium'>Description</th>
                            <th className='text-right py-2 font-medium'>Weighting</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datasets.map(dataset => (
                            <DatasetRow key={dataset.sourceKey} dataset={dataset} />
                        ))}
                    </tbody>
                </table>
            </section>
        </div>
    );
};

export default SonCategoryModal;
